namespace RedBullMOBILE360.BulkSMS {
    export interface BulkSMSForm {
        SmsContent: Serenity.StringEditor;
        SmsType: Serenity.IntegerEditor;
        SmsStatus: Serenity.IntegerEditor;
        SmsDate: Serenity.DateEditor;
    }

    export class BulkSMSForm extends Serenity.PrefixedContext {
        static formKey = 'BulkSMS.BulkSMS';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BulkSMSForm.init)  {
                BulkSMSForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;

                Q.initFormType(BulkSMSForm, [
                    'SmsContent', w0,
                    'SmsType', w1,
                    'SmsStatus', w1,
                    'SmsDate', w2
                ]);
            }
        }
    }
}
